import { TThunk } from '../../..';
import { faqActions } from '../../../config';

export const getCategories = (): TThunk => async (dispatch, getState, api) => {
  const {
    faq: { categories, categoriesLoading },
  } = getState();

  if (categoriesLoading || categories.length) return;

  try {
    dispatch(faqActions.setCategoriesLoading(true));

    const { data } = await api.faq.getCategories();

    dispatch(faqActions.setCategories(data));
  } finally {
    dispatch(faqActions.setCategoriesLoading(false));
  }
};

export const getTopics = (categorySlug: string): TThunk => async (dispatch, getState, api) => {
  const {
    faq: { topics, topicsLoading },
  } = getState();

  if (topicsLoading[categorySlug] || topics[categorySlug]) return;

  try {
    dispatch(faqActions.setTopicsLoading({ categorySlug, value: true }));

    const { data } = await api.faq.getTopics({ category: categorySlug });

    dispatch(faqActions.setTopics({ categorySlug, topics: data }));
  } finally {
    dispatch(faqActions.setTopicsLoading({ categorySlug, value: false }));
  }
};
